<template>
    <div class="kefu">
        <div class="top-banner">
            <div>
                <div  :style="tittlestyle" class="fl tittle">
                    <h2>产品中心-在线客服系统</h2>
                    <p>网络营销必备工具，加强商家与用户之间沟通，增加商品转换量，提高内部管理效率，提升服务价值</p>
                </div>
                <img  src="/site_static/img/service-ban.png" alt="" class="fr banner-img" :style="banlogostyle">
            </div>
        </div>
        <div class="service_start">
            <div class="title" style="padding: 80px 0 70px 0">
                <h3>提升服务价值，从这里开始</h3>
                <p class="service_titleP">“匠心”打造，注重产品功能打磨</p>
            </div>
            <div class="flex poster-container marginauto">
                <div class="start-item">
                    <img src="/site_static/img/serviceImg_1.png" alt="">
                    <p class="item_title">功能更全面</p>
                    <p>接入APP、小程序、公众号、H5</p>
                    <p>全渠道部署，实现多样化沟通</p>
                </div>
                <div class="start-item">
                    <img src="/site_static/img/serviceImg_2.png">
                    <p class="item_title">管理更高效</p>
                    <p>快捷回复、自动分配任务</p>
                    <p>智能化管理，提高20%工作效率</p>
                </div>
                <div class="start-item">
                    <img src="/site_static/img/serviceImg_3.png">
                    <p class="item_title">服务更满意</p>
                    <p>洞察用户与客服需求</p>
                    <p>针对性沟通，提升服务价值</p>
                </div>
            </div>
        </div>
        <div class="common">
            <p class="common_title">多渠道部署，满足多样化需求</p>
            <div class="flex member marginauto" style="padding-bottom: 50px;">
                <div class="member-left" style="width: 530px;">
                    <ul>
                        <li style="padding-bottom: 50px;">
                            <span></span>
                            <p>可接入微信公众号、APP、小程序、H5，多渠道部署，实现客服统一回复和处理。</p>
                        </li>
                        <li>
                            <span></span>
                            <p>可支持文字、图片、语音、商品、订单、优惠券、二维码等对话方式，满足用户和客服之间多样化沟通需求。</p>
                        </li>
                    </ul>
                </div>
                <img src="/site_static/img/service_1.png" class="member-right">
            </div>
        </div>
        <div class="common">
            <p class="common_title">智能化管理，提高工作效率</p>
            <div class="flex member marginauto" style="padding-bottom: 50px;">
                <img src="/site_static/img/service_2.png" class="member-right">
                <div class="member-left" style="width: 530px;">
                    <ul>
                        <li style="padding-bottom: 50px;">
                            <span></span>
                            <p>可设置自动回复、快捷语回复、客服管理等功能，提升客服工作能力，提高工作效率，让您的用户获得最优质的服务。</p>
                        </li>
                        <li>
                            <span></span>
                            <p>根据客服状态自动分配任务；对会话消息进行排列、筛选；转接会员对话等功能，实现客服高效接待客户，提升用户满意度。</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="common">
            <p class="common_title">洞察需求，让运营更全面</p>
            <div class="flex member marginauto" style="padding-bottom: 50px;">
                <div class="member-left" style="width: 530px;">
                    <ul>
                        <li style="padding-bottom: 50px;">
                            <span></span>
                            <p>可查看会员信息、对话记录、满意度评价等信息，多维度了解客户状态和用户需求，针对性的进行沟通，让运营有效全面。</p>
                        </li>
                        <li>
                            <span></span>
                            <p>商家可查看满意度评价、客服数据等信息，多维度了解客服工作状态，并定制相关工作计划，让运营更全面。</p>
                        </li>
                    </ul>
                </div>
                <img src="/site_static/img/service_3.png" class="member-right">
            </div>
        </div>
        <div class="poster">
            <div class="title" style="padding: 52px 0 50px 0">
                <h3>手机聊天页面展示</h3>
                <p class="service_titleP">加强商家与用户之间的关系，辅助商家销售，提升服务价值</p>
            </div>
            <div class="flex poster-container marginauto">
                <div class="poster-item">
                    <img src="/site_static/img/service_pageShow.png">
                </div>
            </div>
        </div>
        <div class="gn_show">
            <div class="title" style="padding: 80px 0 40px 0">
                <h3>功能展示</h3>
            </div>
            <div class="poster-container marginauto">
                <div class="gn-item">
                    <img src="/site_static/img/service_gn_1.png" alt="">
                    <p class="item_title">客服关联会员</p>
                    <p>关联会员会话，优先分配给客服</p>
                    <p>加强用户与商家的黏度</p>
                </div>
                <div class="gn-item">
                    <img src="/site_static/img/service_gn_2.png">
                    <p class="item_title">客服工作量设置</p>
                    <p>设置客服最大接待量</p>
                    <p>保障工作状态</p>
                </div>
                <div class="gn-item">
                    <img src="/site_static/img/service_gn_3.png">
                    <p class="item_title">客服数据</p>
                    <p>查看客服工作数据</p>
                    <p>客服管理工作指标一目了然</p>
                </div>
                <div class="gn-item">
                    <img src="/site_static/img/service_gn_4.png">
                    <p class="item_title">智能回复</p>
                    <p>设置自动回复、快捷语回复</p>
                    <p>方便实用，提高工作效率</p>
                </div>
                <div class="gn-item">
                    <img src="/site_static/img/service_gn_5.png">
                    <p class="item_title">满意度评价</p>
                    <p>对话结束后，对客服进行评价</p>
                    <p>激励客服更好的为用户服务</p>
                </div>
                <div class="gn-item">
                    <img src="/site_static/img/service_gn_6.png">
                    <p class="item_title">会员信息</p>
                    <p>通过查看会员信息，洞悉用户需求</p>
                    <p>提升用户满意度</p>
                </div>
                <div class="gn-item">
                    <img src="/site_static/img/service_gn_7.png">
                    <p class="item_title">不同类型消息</p>
                    <p>可发送文字、图片、语音、表情</p>
                    <p>满足用户多样化沟通需求</p>
                </div>
                <div class="gn-item">
                    <img src="/site_static/img/service_gn_8.png">
                    <p class="item_title">会话消息同步</p>
                    <p>同步APP、小程序、H5、微信公众号会话消息</p>
                    <p>给用户带来更好的体验</p>
                </div>
                <div class="gn-item">
                    <img src="/site_static/img/service_gn_9.png">
                    <p class="item_title">客服分组</p>
                    <p>根据业务需要配置不同客服分组</p>
                    <p>有针对性解决用户提出问题</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'kefu',
        data(){
            return{
                tittlestyle:{},
                banlogostyle:{}
            }
        },
        created: function () {
            let serf = this
            setTimeout(function () {
                serf.tittlestyle={
                    bottom:'125px',
                    opacity: 1}
                serf.banlogostyle={
                    bottom:'45px',
                    opacity: 1}
            },0)

        }
    }
</script>
<style scoped>
    ul{
        list-style: none;
    }
    p{
        margin: 0;
    }
    .flex{
        display: flex;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .top-banner{
        background: url(/site_static/img/service-bg.png) no-repeat;
        color: #fff;
        width: 100%;
        height: 480px;
    }
    .top-banner>div{
        width: 1200px;
        margin: auto;
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    .tittle{
        position: absolute;
        height: 220px;
        transition: all .5s;
        bottom: 0;
        opacity: 0;
    }
    .tittle>h2{
        font-size: 30px;
        margin: 50px 20px 28px 0;
        font-weight: 500;
    }
    .tittle>p{
        font-size: 18px;
        width: 500px;
        line-height: 36px;
        margin-bottom: 30px;
        text-align: left;
    }
    .banner-img{
        position: absolute;
        bottom: 0px;
        opacity: 0;
        transition: all .5s;
    }
    .title {
        padding: 80px 0 50px 0;
        text-align: center;
    }
    .title h3 {
        font-size: 26px;
        color: #3b426b;
        padding-bottom: 20px;
        font-weight: 500;
    }
    .commission{
        background: url(/site_static/img/free.png) no-repeat;
        background-size: 100% 100%;
        height: 240px;
        text-align: center;
        padding-top: 50px;
        box-sizing: border-box;
        color: #fff;
    }
    .commission-tit {
        font-size: 28px;
        padding-bottom: 16px;
    }
    .commission .free {
        width: 116px;
        height: 36px;
        line-height: 36px;
        box-sizing: border-box;
        border-radius: 4px;
        border: 1px solid #fff;
        margin: 0 auto;
        margin-top: 8px;
    }
    .poster-container {
        padding-bottom: 50px;
        justify-content: center;
    }
    .marginauto {
        margin: 0 auto;
        width: 1200px;
    }
    .start-item {
        text-align: center;
        width: 400px;
        padding-right: 20px;
        /* height: 400px; */
    }
    .start-item img {
        margin: 0 auto;
        padding-bottom: 24px;
    }
    .start-item .item_title {
        font-size: 18px;
        color: #3b426b;
        margin-bottom: 20px;
    }
    .start-item p {
        font-size: 14px;
        margin-bottom: 14px;
        color: #7D88A2;
    }
    .common .common_title {
        font-size: 26px;
        color: #3b426b;
        text-align: center;
        margin-top: 20px;
    }
    .member {
        align-items: center;
        padding-top: 50px;
    }
    .member-left {
        padding-left: 40px;
    }
    .member-right {
        padding-left: 20px;
    }
    .common ul li span {
        display: inline-block;
        background-color: #354cf3;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        -moz-border-radius: 4px;
        -webkit-border-radius: 4px;
        float: left;
    }
    .common ul li p {
        display: inline-block;
        font-size: 18px;
        color: #5d6494;
        text-align: left;
        margin-left: 20px;
        margin-top: -24px;
        line-height: 32px;
    }
    .poster{
        background: #f5f8ff;
    }
    .poster-container {
        padding-bottom: 50px;
        justify-content: center;
    }
    .poster-item {
        margin: 0 15px;
    }
    .gn_show{
        overflow: hidden;
        margin-bottom: 80px;
    }
    .gn_show .gn-item {
        float: left;
        width: 340px;
        height: 260px;
        background: none;
        text-align: center;
        margin-left: 45px;
        margin-bottom: 36px;
        box-shadow: 0 3px 16px rgba(230,233,246,0.70);
        -moz-box-shadow: 0 3px 16px rgba(230,233,246,0.70);
        -webkit-box-shadow: 0 3px 16px rgba(230,233,246,0.70);
    }
    .gn_show .gn-item img {
        padding: 16px 0 20px 0;
        margin: 0 auto;
    }
    .gn_show .gn-item .item_title {
        margin-bottom: 20px;
        color: #3b426b;
        font-size: 18px;
    }
    .gn_show .gn-item p {
        font-size: 14px;
        color: #7d88a2;
        margin-bottom: 10px;
    }


</style>



// WEBPACK FOOTER //
// src/components/product/kefu.vue